import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-600">Cargando...</div>
      </div>
    );
  }

  // Se recuerda adónde iba (p. ej. un enlace de invitación o el gasto de un
  // Atajo, con sus parámetros) para volver tras entrar
  return user ? <>{children}</> : <Navigate to="/login" state={{ desde: location.pathname + location.search }} />;
};
